function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.64062 0.494141C4.33984 0.494141 4.125 0.730469 4.125 1.00977V4.61914H2.23438C1.84766 4.61914 1.6543 5.0918 1.93359 5.37109L5.19922 8.63672C5.34961 8.78711 5.62891 8.78711 5.7793 8.63672L9.04492 5.37109C9.32422 5.0918 9.13086 4.61914 8.74414 4.61914H6.875V1.00977C6.875 0.730469 6.63867 0.494141 6.35938 0.494141H4.64062ZM11 8.57227C11 8.29297 10.7637 8.05664 10.4844 8.05664H7.32617L6.27344 9.10938C5.84375 9.56055 5.13477 9.56055 4.70508 9.10938L3.65234 8.05664H0.515625C0.214844 8.05664 0 8.29297 0 8.57227V10.9785C0 11.2793 0.214844 11.4941 0.515625 11.4941H5.5H10.4844C10.7637 11.4941 11 11.2793 11 10.9785V8.57227Z",
  fill: "#2C2C2A"
});

var SvgDownloadIcon = function SvgDownloadIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownloadIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/downloadIcon.afc85a08.svg";
export { ForwardRef as ReactComponent };